/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_TemplateInputs */

const cs_sms_template = /** @type {(inputs: Sms_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíč šablony`)
};

const en_sms_template = /** @type {(inputs: Sms_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template key`)
};

/**
* | output |
* | --- |
* | "Template key" |
*
* @param {Sms_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_template = /** @type {((inputs?: Sms_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_template(inputs)
	return cs_sms_template(inputs)
});